<script>
import StatSites from '../StatSites/StatSites.vue';
import StatNumber from '../StatNumber/StatNumber.vue';
import StatFilters from '../StatFilters/StatFilters.vue';
import StatInventory from '../StatInventory/StatInventory.vue';
import StatList from '../StatList/StatList.vue';
import store from '../../store';
import InfoWidget from '../InfoWidget/InfoWidget.vue';

import {mapState, mapActions} from 'vuex';

export default {
    components: {
        StatSites,
        StatNumber,
        StatFilters,
        StatList,
        StatInventory,
        InfoWidget
    },
    computed: {
        ...mapState({
            totalRevenue: state => state.stats.totalRevenue,
            totalBookings: state => state.stats.totalBookings,
            periodRevenue: state => state.stats.periodRevenue,
            periodBookings: state => state.stats.periodBookings,
            bookingPeriod: state => state.stats.bookingPeriod,
            arrivalPeriod: state => state.stats.arrivalPeriod,
            tips: state => state.stats.tips,
            supplier: state => state.auth.supplier
        })
    },
    watch: {
        supplier: (supplier) => {
            store.dispatch('stats/getPeriodRevenue', supplier.id);
            store.dispatch('stats/getTotalRevenue', supplier.id);
        }
    },
    created () {
        this.toggleNavMenu(false);
        this.getPeriodRevenue(this.supplier.id);
        this.getTotalRevenue(this.supplier.id);
    },
    beforeRouteLeave(to, from, next) {
        Promise.all([
            this.$refs.infoWidget.clean()
        ]).then(() => {
            next();
        });
    },
    destroyed() {
        this.resetState();
    },
    methods: {
        ...mapActions({
            getPeriodRevenue: 'stats/getPeriodRevenue',
            getTotalRevenue: 'stats/getTotalRevenue',
            resetState: 'stats/resetState',
            toggleNavMenu: 'nav/toggleNavMenu'
        })
    }
}
</script>
<template>
    <div class="stat-page">
        <div class="row">
            <div class="col-sm-3 col-xs-6">
                <stat-number
                    :value="periodRevenue.value"
                    :loading="periodRevenue.loading"
                    :error="periodRevenue.error"
                    :no-content="periodRevenue.noContent"
                    :label="$t('subPages.home.labelPeriodRevenue')"
                    :subtitle="$t('subPages.home.subTitleRevenue')"
                    :alternative="false"/>
            </div>
            <div class="col-sm-3 col-xs-6">
                <stat-number
                    :value="periodBookings.value"
                    :loading="periodBookings.loading"
                    :error="periodBookings.error"
                    :no-content="periodBookings.noContent"
                    :label="$t('subPages.home.labelPeriodBookings')"
                    :subtitle="$t('subPages.home.subTitleBookings')"
                    :alternative="false"/>
            </div>
            <div class="col-sm-3 col-xs-6">
                <stat-number
                    :value="totalRevenue.value"
                    :loading="totalRevenue.loading"
                    :error="totalRevenue.error"
                    :no-content="totalRevenue.noContent"
                    :label="$t('subPages.home.labelTotalRevenue')"
                    :subtitle="$t('subPages.home.subTitleRevenue')"
                    :alternative="true"/>
            </div>
            <div class="col-sm-3 col-xs-6">
                <stat-number
                    :value="totalBookings.value"
                    :loading="totalBookings.loading"
                    :error="totalBookings.error"
                    :no-content="totalBookings.noContent"
                    :label="$t('subPages.home.labelTotalBookings')"
                    :subtitle="$t('subPages.home.subTitleBookings')"
                    :alternative="true"/>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <stat-filters/>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <stat-sites/>
                <stat-list/>
            </div>
            <div class="col-lg-6">
                <stat-inventory/>
            </div>
        </div>
        <info-widget ref="infoWidget" :tips="tips"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/StatPage/StatPage.vue